import { SET_GALLERY } from '../actions';

const gallery = (state = [], action) => {
  switch (action.type) {
	case SET_GALLERY:
      return [...action.value];  
    default: return state;
  }
}

export default gallery;
